// The result is rendered with v-html by every caller, and the text is often user-authored (template
// titles, prompt names), so it must be escaped here — the highlight markup is the only HTML allowed out.
function escapeHtml(text) {
  return String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export default function highlightPhrase(phrase, text, useBold = false) {
  if (!phrase) {
    return escapeHtml(text);
  }

  // Normalize phrase: trim and collapse multiple spaces to single space
  const normalizedPhrase = phrase.trim().replace(/\s+/g, ' ');
  // Escape special regex characters except spaces
  const escapedPhrase = normalizedPhrase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  // Create regex pattern that matches with flexible spacing (one or more whitespace chars)
  const flexiblePattern = escapedPhrase.split(' ').join('\\s+');

  const parts = String(text ?? '').split(new RegExp(`(${flexiblePattern})`, 'gi'));
  const className = useBold ? 'font-semibold' : 'bg-yellow-200 py-0.5';

  return parts.map((part) => {
    // Check if this part matches the flexible pattern
    const matchesPattern = new RegExp(`^${flexiblePattern}$`, 'i').test(part);
    return matchesPattern ? `<span class="${className}">${escapeHtml(part)}</span>` : escapeHtml(part);
  }).join('');
}
